import * as React from 'react';
import classnames from 'classnames';

import { AboutPhotosJulia } from '@src/routes/about/components/AboutPhotosJulia';
import { AboutPhotosMeg } from '@src/routes/about/components/AboutPhotosMeg';

import styles from './styles.module.css';

export interface AboutTheTeamProps {
  className?: string;
}

/**
 * @name AboutTheTeam
 * @description About the team and the original founding members.
 */
export const AboutTheTeam = (props: AboutTheTeamProps) => {
  const { className } = props;

  // Styles
  const cssComponent = classnames('ui-bg-gray', styles.component, className);
  const cssContainer = classnames('ui-container-lg', styles.container);

  return (
    <div className={cssComponent}>
      <div className={cssContainer}>
        <p className="py-4x px-6x md:px-0">
          My own love for skincare started 6 years ago, completely out of
          necessity. I had moved to the West Coast and my skin had gotten really
          dry. Everything I had used in the past was just not working. I started
          digging into ingredients and formulations, realizing most of the
          things I was using on my skin were doing more harm than good. I was
          completely unaware of all the new super ingredients that could
          actually help my skin. That was the start of our “cheat sheet,” which
          is why we're here today.
        </p>
        <AboutPhotosMeg className="mt-4x" />
        <h2 className={styles.heading}>
          ...a small passionate team, we build custom skincare routines,{' '}
          <span className="text-pine">one customer at a time.</span>
        </h2>
        <AboutPhotosJulia />
        <div className="px-6x md:px-0">
          <p>
            Along with Julia, my co-founder (without whom I could not do this)
            and a small, passionate team, we continue to build custom skincare
            routines, one customer at a time.
          </p>
          <div className="mt-4x font-give-you-glory text-24">
            Simran &amp; Julia
          </div>
        </div>
      </div>
    </div>
  );
};
